import { Component, OnInit, Input, Inject, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material';
import { Title, Meta } from '@angular/platform-browser';

import { SpeciesService } from '../../specie/species.service';
import { IdiomaService } from '../../idioma/idioma.service';
import { PaisService } from '../pais.service';
import { WindowRef } from '../../window/service/window.service';

@Component({
  selector: 'app-species',
  templateUrl: './species.component.html',
  styleUrls: ['./species.component.scss']
})
export class SpeciesComponent implements OnInit {
  @Input() idioma = '';
  @Input() country = '';
  species = [];
  idiomas = [];
  colores: [];
  filteredItems = [];
  loading = {
    species: true,
    idiomas: true,
    colors: true
  };
  name: string;
  share = {
    facebook: ''
  };
  filteredColors = [];
  speciesByColor = [];
  buscar = false;
  buscarColor = false;

  constructor(
    private route: ActivatedRoute,
    private speciesService: SpeciesService,
    private idiomaService: IdiomaService,
    private paisService: PaisService,
    private chRef: ChangeDetectorRef,
    private windowService: WindowRef,
    private router: Router,
    private snackBar: MatSnackBar,
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) document: any) { }

  assignCopy() {
    this.filteredItems = Object.assign([], this.species);
  }

  filterItem(value) {
    if (!value) {
      this.assignCopy();
    } else if (value.length > 3) {
      this.loading.species = true;

      this.filteredItems = Object.assign([], this.species).filter(
        item => item['COM-NAME'].toLowerCase().indexOf(value.toLowerCase()) > -1 || item['SCI-NAME'].toLowerCase().indexOf(value.toLowerCase()) > -1
      );

      this.loading.species = false;

      this.snackBar.open('especies (' + this.filteredItems.length + ') colores (' + this.filteredColors.length + ')', 'busqueda', {
        duration: 500,
      });
    }
  }

  filterItemByColor(pSpecies: any) {
    if (pSpecies.length === 0) {
      this.assignCopy();
    } else {
      this.filteredItems = Object.assign([], this.species).filter((item) => {
        if (pSpecies.filter((specieItem) => {
          return specieItem['SCI-NAME'].toLowerCase() === item['SCI-NAME'].toLowerCase();
        }).length > 0) {
          return item;
        } else {
          return false;
        }
      });
    }
  }

  getSpecies() {
    this.loading.species = true;
    this.speciesService
      .getSpeciesByCountryByLanguage(this.country, this.idioma)
      .subscribe((data: any) => {

        this.species = data.response;
        this.loading.species = false;
        this.assignCopy();
        //this.chRef.detectChanges();
        this.getColors();
      });
  }

  getColors() {
    this.loading.colors = true;
    this.paisService
      .getColores(this.country)
      .subscribe((data: any) => {

        this.colores = data.response;
        this.loading.colors = false;
        //this.chRef.detectChanges();
      });
  }

  getIdiomas() {
    this.loading.idiomas = true;
    this.idiomaService
      .getLanguages()
      .subscribe((data: any) => {

        this.idiomas = data.response;
        this.loading.idiomas = false;
      });
  }

  getBackgroundColorStyle(pHexColor: string) {
    return {
      'background-color': pHexColor,
      'border': '1px solid #CCCCCC'
    }
  }

  gotoCountryIdioma(pIdioma: any) {
    this.router.navigate(['/pais/species/' + this.country + '/' + pIdioma]);
  }

  getSpeciesByColor(pColor: any) {
    if (!pColor.selected) {
      pColor.selected = true;
      this.filteredColors.push(pColor.COLOR);
      this.loading.species = true;

      this.speciesService
        .getSpeciesByColorByIdioma(this.idioma, this.windowService.nativeWindow.escape(pColor.COLOR))
        .subscribe((data: any) => {

          this.speciesByColor = this.speciesByColor.concat(data.response);
          this.loading.species = false;
          this.filterItemByColor(this.speciesByColor);
          this.snackBar.open('especies (' + this.filteredItems.length + ') colores (' + this.filteredColors.length + ') idioma (' + this.idioma + ')', 'busqueda', {
            duration: 5000,
          });
        });

    } else {
      delete pColor.selected;
      this.filteredColors.splice(this.filteredColors.indexOf(pColor.COLOR), 1);

      this.loading.species = true;
      for (let i = 0; i < this.speciesByColor.length; i++) {
        if (this.speciesByColor[i].COLOR === pColor.COLOR) {
          this.speciesByColor.splice(i, this.speciesByColor.filter((item) => {
            return item.COLOR === pColor.COLOR;
          }).length);
        }
      }

      this.filterItemByColor(this.speciesByColor);
      this.loading.species = false;
      this.snackBar.open('especies (' + this.filteredItems.length + ') colores (' + this.filteredColors.length + ') idioma (' + this.idioma + ')', 'busqueda', {
        duration: 5000,
      });
    }
  }

  resetColors() {
    this.filteredColors = [];

    for (var i = 0; i < this.colores.length; i++) {
      delete this.colores[i]['selected'];
    }

    this.assignCopy();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idioma = params['idioma'];
      this.country = params['country'];
      this.share.facebook = document.location.href;
      this.getSpecies();
      this.getIdiomas();
      this.titleService.setTitle(this.country + '/GlobalBirdWatching.org');

      this.metaService.updateTag({ property: 'og:url', content: document.location.href });
      this.metaService.updateTag({ property: 'og:type', content: 'website' });
      this.metaService.updateTag({ property: 'og:title', content: this.country + ' GlobalBirdWatching.org' });
      this.metaService.updateTag({ property: 'og:description', content: 'GlobalBirdWatching.org. Listado de Especies en ' + this.country + ' en idioma ' + this.idioma });
      this.metaService.updateTag({ property: 'og:image', content: 'https://images.globalbirdwatching.org/images/globalbirdwatching.png' });

      this.share.facebook += '?type=website&title=' + escape(this.country) + ' GlobalBirdWatching.org' + '&description=' + 'GlobalBirdWatching.org. Listado de Especies en ' + escape(this.country) + ' en idioma ' + this.idioma + '&image=https://images.globalbirdwatching.org/images/flags/png250px/' + this.country.toLowerCase() + '.jpg';
    });
  }

}
